// @flow
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
}                  from '../../utils';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    busy:  false,
    error: null,
    items: [],
    item:  null,
});

export default class TransactionsReducer extends Reducer {
    NAME = 'Transactions';

    alias = {
        [ TYPES.TRANSACTIONS_GET_REQUEST ]:   'onGetRequest',
        [ TYPES.TRANSACTIONS_GET_SUCCESS ]:   'onGetSuccess',
        [ TYPES.TRANSACTIONS_GET_FAIL ]:      'onGetFailure',
        [ TYPES.TRANSACTION_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.TRANSACTION_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.TRANSACTION_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.TRANSACTION_LOAD_REQUEST ]:   'onItemLoadRequest',
        [ TYPES.TRANSACTION_LOAD_SUCCESS ]:   'onItemLoadSuccess',
        [ TYPES.TRANSACTION_LOAD_FAIL ]:      'onItemLoadFailure',
        [ TYPES.TRANSACTION_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.TRANSACTION_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.TRANSACTION_UPDATE_FAIL ]:    'onItemUpdateFailure',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

}
